export const operationType = {
  UNDO: 'undo',
  REDO: 'redo',
};
